import styled from "styled-components";

import { NavLink } from "react-router-dom";

import { colors } from "shared/ui";

export const Root = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 24px 16px;
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Hint = styled.div`
    text-align: center;
    font-size: 14px;
    line-height: 1.5;
    color: ${colors.textSecondary};
`;

export const TextLink = styled(NavLink)`
    align-self: center;
    font-size: 14px;
    color: ${colors.primary};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;
